import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { promosApi, type PromoInput } from "@/api/promos.api";
import { queryKeys } from "@/utils/queryKeys";

export function usePromosList() {
  return useQuery({
    queryKey: queryKeys.promos.list(),
    queryFn: promosApi.list,
  });
}

function useInvalidatePromos() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: queryKeys.promos.list() });
}

export function useCreatePromo() {
  const invalidate = useInvalidatePromos();
  return useMutation({
    mutationFn: (payload: PromoInput) => promosApi.create(payload),
    onSuccess: invalidate,
  });
}

export function useUpdatePromo() {
  const invalidate = useInvalidatePromos();
  return useMutation({
    mutationFn: ({ id, ...payload }: { id: string } & Partial<PromoInput>) => promosApi.update(id, payload),
    onSuccess: invalidate,
  });
}
